const EXEMPTED_PATHS = ['/iframe', '/contact-sales'];

export const isEmbeddedContext = (): boolean => {
  if (typeof globalThis.location === 'undefined') return false;

  const isFramed = globalThis.self !== globalThis.top;
  const isIframePath = globalThis.location.pathname === '/iframe';

  return isFramed || isIframePath;
};

const getLoginUrl = (): string => {
  const slashDev =
    import.meta.env.VITE_BASE_URL === 'http://localhost:3000' ? '/dev' : '';

  return `${import.meta.env.VITE_API_BASE_URL}/v1/auth/login${slashDev}`;
};

const getSafeRedirect = (value: string | null): string => {
  if (!value) return '';

  const decoded = (() => {
    try {
      return decodeURIComponent(value);
    } catch {
      return '';
    }
  })();

  if (!decoded.startsWith('/') || decoded.startsWith('//')) return '';

  return decoded;
};

export const redirectToLogin = (redirectPath?: string): boolean => {
  if (typeof globalThis.location === 'undefined') return false;
  if (isEmbeddedContext()) return false;

  const safePath = getSafeRedirect(redirectPath ?? null);
  const query = safePath ? `?redirect=${encodeURIComponent(safePath)}` : '';

  globalThis.location.replace(`${getLoginUrl()}${query}`);

  return true;
};

export const authCheck = () => {
  if (typeof globalThis.location === 'undefined') return;

  const url = new URL(globalThis.location.href);
  const isApkPath = url.pathname === '/apk';
  const isExemptedPath = EXEMPTED_PATHS.includes(url.pathname);
  const email = url.searchParams.get('email');
  const accessToken = url.searchParams.get('access_token');

  if (accessToken && accessToken.trim() !== '') {
    globalThis.localStorage.setItem('token', accessToken);

    if (isEmbeddedContext()) {
      url.searchParams.delete('access_token');
      globalThis.history.replaceState({}, '', url.toString());
      return;
    }

    const redirectTarget = getSafeRedirect(
      url.searchParams.get('redirect') ?? url.searchParams.get('redirect_to')
    );

    globalThis.location.replace(
      `${import.meta.env.VITE_BASE_URL}${redirectTarget}`
    );
  } else if (isApkPath && email && email.trim() !== '') {
    return;
  } else if (isExemptedPath) {
    return;
  } else if (isEmbeddedContext()) {
    return;
  } else if (import.meta.env.VITE_CHATBOT_IFRAME_URL !== 'https://chat.kazee.ai') {
    const token = globalThis.localStorage.getItem('token');
    const isTokenInvalid = ['undefined', 'null', ''].includes(token ?? '');
    const isLoginPage = globalThis.location.pathname === '/auth/login';

    if (isTokenInvalid && !isLoginPage) {
      redirectToLogin(`${url.pathname}${url.search}`);
    }
  }
};
